import { Navigate } from 'react-router-dom';

interface AuthProps {
  children: React.ReactElement;
  logged: boolean;
}

export default function Auth({ children, logged }: AuthProps) {
  // Kiểm tra nếu chưa đăng nhập thì redirect về trang login
  if (!logged) {
    return <Navigate to="/login" replace />;
  }

  // Nếu đã đăng nhập thì render children
  return children;
}
